import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { findHelpTopic, type HelpTopic } from "./helpTopics.ts";

// The panel is mounted once in app.vue, so the trigger (sidebar button, header
// marker, or any future inline marker) and the panel itself never need to be
// siblings.
export const useHelpPanelStore = defineStore("helpPanel", () => {
  const isOpen = ref(false);
  const activeTopicId = ref<string | undefined>(undefined);

  const activeTopic = computed<HelpTopic | undefined>(() =>
    findHelpTopic(activeTopicId.value)
  );

  /** Omit the id to open at the table of contents. */
  function open(topicId?: string): void {
    activeTopicId.value = topicId;
    isOpen.value = true;
  }

  function showTableOfContents(): void {
    activeTopicId.value = undefined;
  }

  function close(): void {
    isOpen.value = false;
  }

  return {
    isOpen,
    activeTopicId,
    activeTopic,
    open,
    showTableOfContents,
    close,
  };
});
